export class VisibilityScheduler {
    public schedule<T>(cb: () => T | Promise<T>): Promise<T> {
        const { document } = window;
        if (!document || document.visibilityState === 'visible') {
            // Schedule microtask
            return Promise.resolve().then(cb);
        }

        return new Promise((resolve, reject) => {
            const handler = () => {
                if (document.visibilityState === 'visible') {
                    Promise.resolve().then(cb).then(resolve).catch(reject);
                    document.removeEventListener('visibilitychange', handler);
                }
            };
            // Schedule when document becomes visible
            document.addEventListener('visibilitychange', handler);
        });
    }
}
